module.exports = __webpack_public_path__ + "static/img/icon_man_question.802fb873.svg";